module.exports = __webpack_public_path__ + "static/media/2019SummerReg.cea24ab2.pdf";